// extracted by mini-css-extract-plugin
export default {"default":"Pagination_default__Oktq7"};